module.exports = __webpack_public_path__ + "static/media/shell32_8.43ef80d0.ico";